module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-5_BW-p-1600-151d650526a6a2b1b8d07bf27ba9da94.jpg";